/*
 * View for working with Recommendations
 */

define(["marionette", "./template/recommendationsTemplate.html"], function (
  Marionette,
  RecommendationsTemplate,
) {
  var RecommendationsView = {};

  RecommendationsView.recommendationsView = Marionette.ItemView.extend({
    template: RecommendationsTemplate,
    modelEvents: {
      sync: "render",
    },
    triggers: {
      "click #refreshTopicSearch": "recommendations:refresh:click",
      "click #refreshTopicSearchFull": "recommendations:refreshFull:click",
    },
  });

  return RecommendationsView;
});
